import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {RootState} from 'App/store/rootReducer';

import {Credentials} from './userTypes';

type UserSlice = {
  credentials: Credentials | null;
  isAutoAuthenticationDone: boolean;
  isRequesting: boolean;
  status: string | null;
};

const initialState: UserSlice = {
  credentials: null,
  isAutoAuthenticationDone: false,
  isRequesting: false,
  status: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Credentials>) => {
      state.credentials = action.payload;
      state.isRequesting = false;
      state.status = null;
    },
    logout: state => {
      state.credentials = null;
      state.isRequesting = false;
      state.status = null;
    },
    update: (state, action: PayloadAction<Credentials>) => {
      state.credentials = action.payload;
      state.isRequesting = false;
      state.status = null;
    },
    requesting: state => {
      state.isRequesting = true;
      state.status = null;
    },
    success: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
      state.isRequesting = false;
    },
    fail: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
      state.isRequesting = false;
    },
    autoAuthenticationDone: state => {
      state.isAutoAuthenticationDone = true;
    },
  },
});

const mapUserToProps = (state: RootState): UserSlice => state.user;
export const connectToUser = connect(mapUserToProps, null, null, {
  forwardRef: true,
});

export const selectUserCredentials = (state: RootState): Credentials | null =>
  state.user.credentials;

export const {
  login,
  logout,
  update,
  requesting,
  success,
  fail,
  autoAuthenticationDone,
} = userSlice.actions;

export default userSlice.reducer;
